import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const textFieldStyles = style({
  flexGrow: 1,
  $nest: {
    '& input': {
      width: '100%'
    }
  }
});

export const dialogBodyStyles: React.CSSProperties = {
  display: 'inline-block',
  width: '100%'
};

export const groupNameFieldStyles: React.CSSProperties = {
  width: '380px'
};

export const siteRolePickerMenuStyles: React.CSSProperties = {
  width: '100%',
  marginLeft: TabStyles.Spacing.LargeSpace
};

export const outerCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.DefaultSpace
};

export const externalUserCheckboxStyles: React.CSSProperties = {
  marginBottom: TabStyles.Spacing.SmallSpace
};

export const dialogElementStyles: React.CSSProperties = {
  display: 'inline-flex'
};

export const labelStyles: React.CSSProperties = {
  width: '150px',
};

export const externalUserLabelStyles: React.CSSProperties = {
  width: '225px',
};

export const externalUserTextLinkStyles: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.LargeSpace
};

export const externalUserWarningStyles: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.LargeSpace,
  width: '360px'
};

export const grantLicenseIntegrationUsersAlertStyles: React.CSSProperties = {
  marginLeft: 0,
  marginBottom: TabStyles.Spacing.DefaultSpace,
  width: '100%',
  padding: TabStyles.Spacing.SmallSpace
};